theme.headerSection = (function () {
  function header() {
    /* Mobile Menu Function */
    const MobileMenu = function () {
      const offcanvasOpenButtons = document.querySelectorAll(
          ".header__actions_btn--menu, .mobile__menu_bar"
        ),
        offcanvasClose = document.querySelector(".offcanvas__close_btn"),
        offcanvasHeader = document.querySelector(".offcanvas-header"),
        offcanvasOverlay = document.querySelector(".offcanvas-overlay"),
        offcanvasMenuAll = document.querySelectorAll(".offcanvas__menu"),
        body = document.querySelector("body");

      function openMobileMenu() {
        if (offcanvasHeader) offcanvasHeader.classList.add("open");
        if (offcanvasOverlay) offcanvasOverlay.classList.add("active");
        if (body) body.style.overflowY = "hidden";
      }

      function closeMobileMenu() {
        if (offcanvasHeader) offcanvasHeader.classList.remove("open");
        if (offcanvasOverlay) offcanvasOverlay.classList.remove("active");
        if (body) body.style.overflowY = null;
      }

      /* Open/Close Menu On Click Toggle Button */
      if (offcanvasOpenButtons.length > 0) {
        offcanvasOpenButtons.forEach((btn) => {
          btn.addEventListener("click", function (e) {
            e.preventDefault();
            openMobileMenu();
          });
        });
      }

      if (offcanvasClose) {
        offcanvasClose.addEventListener("click", function (e) {
          e.preventDefault();
          closeMobileMenu();
        });
      }

      if (offcanvasOverlay) {
        offcanvasOverlay.addEventListener("click", function (e) {
          e.preventDefault();
          closeMobileMenu();
        });
      }

      /* Close Menu when clicking any link inside offcanvas header */
      if (offcanvasHeader) {
        offcanvasHeader.querySelectorAll("a").forEach(function (link) {
          link.addEventListener("click", function () {
            closeMobileMenu();
          });
        });
      }

      /* Close Menu on Escape key */
      document.addEventListener("keydown", function (e) {
        if (e.key === "Escape") {
          closeMobileMenu();
        }
      });
      /* Open/Close Sub Menu On Click Toggle Button */

      if (offcanvasMenuAll.length > 0) {
        offcanvasMenuAll.forEach((offcanvasMenu) => {
          /* Add a Button For SubMenu Toggle */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu")
            .forEach(function (ul) {
              const subMenuToggle = document.createElement("button");
              subMenuToggle.classList.add("offcanvas__sub_menu_toggle");
              subMenuToggle.setAttribute("aria-label", "menu collapse");
              ul.parentNode.appendChild(subMenuToggle);
            });

          /* Submenu toggle */
          offcanvasMenu
            .querySelectorAll(".offcanvas__sub_menu_toggle")
            .forEach(function (toggle) {
              toggle.addEventListener("click", function (e) {
                e.preventDefault();
                const parent = this.parentElement;
                if (parent.classList.contains("active")) {
                  this.classList.remove("active");
                  parent.classList.remove("active");
                  parent
                    .querySelectorAll(".offcanvas__sub_menu")
                    .forEach(function (subMenu) {
                      subMenu.parentElement.classList.remove("active");
                      subMenu.nextElementSibling.classList.remove("active");
                      slideUp(subMenu);
                    });
                } else {
                  this.classList.add("active");
                  parent.classList.add("active");
                  slideDown(this.previousElementSibling);
                  getSiblings(parent).forEach(function (item) {
                    item.classList.remove("active");
                    item
                      .querySelectorAll(".offcanvas__sub_menu")
                      .forEach(function (subMenu) {
                        subMenu.parentElement.classList.remove("active");
                        subMenu.nextElementSibling.classList.remove("active");
                        slideUp(subMenu);
                      });
                  });
                }
              });
            });
        });
      }

      document.addEventListener("click", function (event) {
        if (!offcanvasHeader || !offcanvasHeader.classList.contains("open")) return;
        if (
          !event.target.closest(".header__actions_btn--menu") &&
          !event.target.closest(".mobile__menu_bar") &&
          !event.target.closest(".offcanvas-header")
        ) {
          closeMobileMenu();
        }
      });

      /* Remove Mobile Menu Open Class & Hide Mobile Menu When Window Width is More Than 991 */
      window.addEventListener("resize", function () {
        if (window.outerWidth >= 992 || window.innerWidth >= 992) {
          closeMobileMenu();
        }
      });
    };
    /* Mobile Menu Active */
    MobileMenu();

    /* Menu toggle buttons */
    const mobileMenuToggleButtons = document.querySelectorAll(
      ".mobile--menu-header-button"
    );
    const mobileMainMenu = document.querySelector(".mobile__main-menu--list");
    const mobileVerticalMenu = document.querySelector(
      ".mobile__categories--list"
    );
    if (mobileMenuToggleButtons.length > 0) {
      mobileMenuToggleButtons.forEach((button) => {
        button?.addEventListener("click", function (e) {
          mobileMenuToggleButtons.forEach((childButton) => {
            childButton.classList.remove("active");
          });
          if (button.classList.contains("mobile__main--menu")) {
            button.classList.add("active");
            if (mobileMainMenu.classList.contains("d-none")) {
              mobileMainMenu.classList.remove("d-none");
            }
            mobileVerticalMenu.classList.add("d-none");
          }
          if (button.classList.contains("mobile__categories--menu")) {
            button.classList.add("active");
            if (mobileVerticalMenu.classList.contains("d-none")) {
              mobileVerticalMenu.classList.remove("d-none");
            }
            mobileMainMenu.classList.add("d-none");
          }
        });
      });
    }
  }

  return header;
})();
